var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.178 11.034a5.038 5.038 0 01-.888 2.82 5.157 5.157 0 01-2.329 1.86 5.248 5.248 0 01-2.985.277 5.198 5.198 0 01-2.64-1.402 5.068 5.068 0 01-1.406-2.608 5.02 5.02 0 01.3-2.938 5.11 5.11 0 011.906-2.28 5.23 5.23 0 014.855-.46c.629.258 1.2.636 1.68 1.112.48.476.86 1.041 1.12 1.662.258.62.39 1.286.387 1.957zm5.667 0c0 2.66-1.161 4.82-2.586 4.82-1.426 0-2.587-2.16-2.587-4.82s1.161-4.821 2.587-4.821c1.425 0 2.586 2.15 2.586 4.821zm2.322 0c0 2.388-.403 4.323-.908 4.323-.506 0-.908-1.935-.908-4.323 0-2.388.402-4.323.908-4.323.505 0 .908 1.935.908 4.323z",
    fill: "#fff"
  })));
}
export default SvgMedium;